const NOOP = () => {};

const restoreAttribute = (element, name, previousValue) => {
  if (previousValue == null) element.removeAttribute(name);
  else element.setAttribute(name, previousValue);
};

/**
 * Keep Draft.js contenteditable so its selection events and anchor mapping keep
 * working, but tell mobile browsers that this surface must not summon a text
 * input keyboard. Changing contenteditable itself breaks reader selections in
 * iOS WebViews, so this deliberately changes only virtual-keyboard metadata.
 */
export const configureMobileReaderSelectionSurface = (
  root,
  { enabled, isSmallScreen }
) => {
  if (!enabled || !isSmallScreen || !root?.querySelectorAll) return NOOP;

  const editors = Array.from(
    root.querySelectorAll('[contenteditable="true"]')
  );
  const previousAttributes = editors.map(editor => ({
    editor,
    inputMode: editor.getAttribute('inputmode'),
    virtualKeyboardPolicy: editor.getAttribute('virtualkeyboardpolicy'),
    ariaReadOnly: editor.getAttribute('aria-readonly'),
  }));

  editors.forEach(editor => {
    editor.setAttribute('inputmode', 'none');
    editor.setAttribute('virtualkeyboardpolicy', 'manual');
    editor.setAttribute('aria-readonly', 'true');
  });

  return () => {
    previousAttributes.forEach(
      ({ editor, inputMode, virtualKeyboardPolicy, ariaReadOnly }) => {
        restoreAttribute(editor, 'inputmode', inputMode);
        restoreAttribute(
          editor,
          'virtualkeyboardpolicy',
          virtualKeyboardPolicy
        );
        restoreAttribute(editor, 'aria-readonly', ariaReadOnly);
      }
    );
  };
};

export const blockMobileReaderSelectionMenu = (
  event,
  { enabled, isSmallScreen }
) => {
  if (enabled && isSmallScreen) event.preventDefault();
};
